export const stripAugmentation = (text) => text.replace(/\s*\([^)]+\)\s*$/, "")
